import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes related to user management, including paths and icons using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  TRANSACTION_HISTORY: {
    path: `${baseRoutes.adminBaseRoutes}/transactions-history`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-repeat" />
      </span>
    ),
  },
};

export default accessRoute;
